import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },

  color: {
    marginTop: '2px',
    marginLeft: '0.5rem'
  }
}))

export default useStyles
